import React from 'react'

const BarangayVisionMission = ({ barangay }) => {
  if (!barangay.vision && !barangay.mission) return null

  const hasVision = barangay.vision && barangay.vision.trim()
  const hasMission = barangay.mission && barangay.mission.trim()
  const columnClass = (hasVision && hasMission) ? 'col-lg-6' : 'col-lg-8'

  return (
    <section className="section bg-light">
      <div className="container">
        <div className="section-head text-center mb-5">
          <h2 className="title title-s4">Our Vision & Mission</h2>
        </div>
        <div className="row gutter-vr-40px justify-content-center">
          {hasVision && (
            <div className={columnClass}>
              <div className="feature-card h-100" style={{ border: '2px solid #e02f29', padding: '30px', borderRadius: '8px' }}>
                <div className="feature-icon mb-4">
                  <em className="fas fa-eye" style={{ fontSize: '3rem', color: '#e02f29' }}></em>
                </div>
                <h3 className="title title-sm mb-3">Vision</h3>
                <p style={{ fontSize: '1rem', lineHeight: '1.7', textAlign: 'justify' }}>
                  {barangay.vision}
                </p>
              </div>
            </div>
          )}
          {hasMission && (
            <div className={columnClass}>
              <div className="feature-card h-100" style={{ border: '2px solid #e02f29', padding: '30px', borderRadius: '8px' }}>
                <div className="feature-icon mb-4">
                  <em className="fas fa-bullseye" style={{ fontSize: '3rem', color: '#e02f29' }}></em>
                </div>
                <h3 className="title title-sm mb-3">Mission</h3>
                <p style={{ fontSize: '1rem', lineHeight: '1.7', textAlign: 'justify' }}>
                  {barangay.mission}
                </p>
              </div>
            </div>
          )}
        </div>
      </div>
    </section>
  )
}

export default BarangayVisionMission
